import { Box, ButtonBase, makeStyles, Typography } from "@material-ui/core";
import React from "react";
import { useHistory } from "react-router";

import { homeCardStyle, HomeSection } from "@/components/home/HomeSection";
import { ProgressBar } from "@/components/ProgressBar";
import { LEARNING_STAGES, STAGE_IMAGE_MAP } from "@/constants/learning";
import { layoutTokens, semanticColors, textStyles } from "@/designTokens";
import { useLearningProgress } from "@/hooks/useLearningProgress";

const useStyles = makeStyles({
  list: { display: "flex", flexDirection: "column", gap: layoutTokens.space[8] },
  card: {
    ...homeCardStyle,
    display: "flex",
    alignItems: "center",
    gap: layoutTokens.space[12],
    padding: `${layoutTokens.space[12]}px ${layoutTokens.space[16]}px`,
    width: "100%",
    textAlign: "left",
  },
  image: {
    width: 64,
    height: 64,
    borderRadius: layoutTokens.radius.md,
    objectFit: "cover",
    backgroundColor: semanticColors["field/bg"],
    flexShrink: 0,
  },
  body: { flex: 1, minWidth: 0 },
  level: { ...textStyles["SP/Body/Small"], color: semanticColors["action/primary"] },
  title: { ...textStyles["SP/Body/Large"], color: semanticColors["text/primary"], marginTop: layoutTokens.space[4] },
  chapters: {
    ...textStyles["SP/Body/Small"],
    color: semanticColors["text/secondary"],
    marginTop: layoutTokens.space[4],
  },
  progress: { width: 32, height: 4, flexShrink: 0, borderRadius: layoutTokens.radius.full },
});

const homeLearningTitles = [
  "不動産投資の全体像や、基礎用語を理解する",
  "収支計算・運営管理など、実際に使うノウハウを学ぶ",
  "法人化・ポートフォリオ戦略や出口戦略について学ぶ",
];

export const LearningSection: React.FC = () => {
  const classes = useStyles();
  const history = useHistory();
  const { statusMap, initialized, loading, error } = useLearningProgress();
  return (
    <HomeSection title="学習コンテンツ" onViewAll={() => history.push("/learning")}>
      <Box className={classes.list}>
        {LEARNING_STAGES.map((stage, index) => {
          const completed = stage.articles.filter((article) => Boolean(statusMap[article.id])).length;
          const total = stage.articles.length;
          const known = initialized && !loading && !error;
          return (
            <ButtonBase key={stage.id} className={classes.card} onClick={() => history.push(`/learning/${stage.id}`)}>
              <img className={classes.image} src={STAGE_IMAGE_MAP[stage.id]} alt="" />
              <Box className={classes.body}>
                <Typography className={classes.level}>{stage.label.replace("編", "")}</Typography>
                <Typography className={classes.title}>{homeLearningTitles[index]}</Typography>
                <Typography className={classes.chapters}>
                  全{total}章{known && completed > 0 ? `・${completed}章学習済み` : ""}
                </Typography>
              </Box>
              {known && (
                <ProgressBar
                  className={classes.progress}
                  value={total ? (completed / total) * 100 : 0}
                  aria-label={`${stage.label}の学習進捗`}
                />
              )}
            </ButtonBase>
          );
        })}
      </Box>
    </HomeSection>
  );
};

export default LearningSection;
